<template>
  <SModal
    v-model="displayModal"
    centered
    :header-title="$t('settings.index.videos.title')"
    hide-footer
    body-class="p-2"
    dialog-class="sdui-video-modal-dialog"
    :modal-class="withTransition ? 'sdui-video-modal-transition' : undefined"
    @hide="$emit('close')"
  >
    <div v-if="displayModal" class="video-instructions-wrapper">
      <div class="video position-relative">
        <iframe
          v-if="!isStatic"
          :src="videoSource"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          :title="iframeTitle"
          data-test="sdui-video"
        />
        <video v-else
               class="static-video"
               width="100%"
               height="100%"
               controls
               playsinline
               :src="videoSource"
               data-test="sdui-video"
        />
      </div>
    </div>
  </SModal>
</template>

<script>
export default {
  name: 'SduiVideoModal',
  props: {
    videoSource: {
      type: String,
      default: '',
    },

    showVideo: {
      type: Boolean,
      default: false,
    },

    iframeTitle: {
      type: String,
      default: '',
    },

    withTransition: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    displayModal: false,
  }),

  computed: {
    isStatic() {
      return this.videoSource?.startsWith(this.$t('management.school_year_change.general.video_link.base_url'))
    },
  },

  emits: ['close'],

  methods: {},
  watch: {
    showVideo: {
      handler: async function (newVal) {
        await this.$nextTick()
        this.displayModal = newVal
      },
    },
  },
}
</script>

<!-- Unscoped because modal is attached to body -->
<style lang="scss">
.sdui-video-modal-dialog {
  max-width: 1024px !important;

  .video-instructions-wrapper {
    iframe {
      width: 100% !important;
      height: 100% !important;
      border-radius: 16px !important;
    }

    .video {
      border-radius: 12px;
      height: 576px !important;
      background: $color-black;
      width: 100%;
      overflow: hidden;

      @include media($mobile) {
        height: 196px !important;
      }
    }
  }
}

.sdui-video-modal-transition {
  &.modal {
    &.fade.show .modal-dialog {
      transform: translate3d(0, 0, 0);
      transition: 0.2s ease-out;
    }

    &.fade:not(.show) .modal-dialog {
      transform: translate3d(100%, 0, 0);
      transition: 0.2s ease-in;
    }
  }
}
</style>
